<app-back text="Back to Answers" [reset]="false" [goToView]="e.ChatView.ShortListOfAnswers"></app-back>
<app-explorer-full-response *ngIf="e.selectedAnswer" [results]="e.selectedAnswer.Result"
  [focus]="e.selectedAnswer.Focus" [unused]="e.selectedAnswer.Unused" [score]="e.selectedAnswer.Score"
  [date]="e.getTime(0)"></app-explorer-full-response>